import { render, staticRenderFns } from "./createuserinfo.vue?vue&type=template&id=478cf1a6&scoped=true&"
import script from "./createuserinfo.vue?vue&type=script&lang=js&"
export * from "./createuserinfo.vue?vue&type=script&lang=js&"
import style0 from "./createuserinfo.vue?vue&type=style&index=0&id=478cf1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478cf1a6",
  null
  
)

export default component.exports